<template>
  <div class="step-1">
    <div class="step-1-text">希望别人怎么称呼我：</div>
    <NfInput round=".5rem" :value.sync="formValue.name" />
    <template v-if="formValue.isPass">
      <div class="step-1-text">游戏密码：</div>
      <NfInput round=".5rem" :value.sync="formValue.password" type="password" />
    </template>
  </div>
</template>

<script>
import NfInput from "@/components/game-ui/NfInput.vue";
export default {
  components: {
    NfInput,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.step-1 {
  &-text {
    padding: 0 0.5rem;
    margin: 0.3rem 0  0.2rem 0;
    font-weight: 600;
  }
}
</style>
